import React, { useState } from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'

function HILTeamsMweb({ teamData, isMobile = false }) {
  const [filter, setFilter] = useState('Men')

  const teamDataToMap = filter === 'Men' ? teamData?.filter(d => d?.gender === 'male') : teamData?.filter(d => d?.gender === 'female')
  return (
    <>
      <div className="d-flex justify-content-between align-items-center w-100 mt-4">
        <h2 className={`${styles.title} mt-2`}>Teams</h2>
        <div className={styles.filterContainer}>
          <button className={`${styles.filterButton} ${filter === 'Men' ? styles.activeFilter : ''}`} onClick={() => setFilter('Men')}>
            Men
          </button>
          <button className={`${styles.filterButton} ${filter === 'Women' ? styles.activeFilter : ''}`} onClick={() => setFilter('Women')}>
            Women
          </button>
        </div>
      </div>

      <div className={`${styles.mainContainer}`}>
        {teamDataToMap?.map((a, i) => {
          if (a?.articleSlug) {
            return (
              <CustomLink key={i} href={isMobile ? `/${a?.articleSlug}/mobile` : `/${a?.articleSlug}`} className="cursor-pointer">
                <div className="flex flex-column">
                  <div className={styles.teamContainer}>
                    <MyImage src={a?.logo} height={150} width={150} />
                  </div>
                  <h6 className={styles.teamName}>{a?.teamName}</h6>
                </div>
              </CustomLink>
            )
          } else {
            return (
              <div key={i} className="cursor-pointer">
                <div className={styles.teamContainer}>
                  <MyImage src={a?.logo} height={150} width={150} />
                </div>
                <h6 className={styles.teamName}>{a?.teamName}</h6>
              </div>
            )
          }
        })}
      </div>
    </>
  )
}

HILTeamsMweb.propTypes = {
  teamData: PropTypes.array,
  isMobile: PropTypes.bool
}

export default HILTeamsMweb
